<template>
  <v-container>
    <el-container v-loading.fullscreen.lock="loading">
      <el-header height="auto">
        <el-row type="flex" align="middle">
          <el-col>
            <el-form size="small" inline>
              <el-form-item label="手机号">
                <el-input v-model.trim="form.phone" placeholder="输入手机号查询" clearable style="width: 160px;"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="reload">搜索</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-header>
      <el-main>
        <el-table :data="list" :row-class-name="tableRowClassName">
          <el-table-column prop="nickname" label="昵称" width="200" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="ifAdmin" label="是否管理员" width="200" align="center" :formatter="row => row.ifAdmin === 1 ? '是' : '否'"></el-table-column>
          <el-table-column label="头像" width="200" align="center">
            <template slot-scope="scope">
              <file-image style="max-width: 100%; height: 100px;" fit="contain" :src="scope.row.avatar" />
            </template>
          </el-table-column>
          <el-table-column prop="sex" label="性别" width="140" align="center" :formatter="row => SEX_MAP.get(row.sex) || '--'"></el-table-column>
          <el-table-column prop="status" label="状态" width="140" align="center" :formatter="row => USER_STATUS_MAP.get(row.status) || '--'"></el-table-column>
          <el-table-column prop="phone" label="手机号码" width="120" align="center"></el-table-column>
          <el-table-column prop="companyName" label="公司名称" min-width="120" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="companyAddress" label="公司地址" min-width="200" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="industryName" label="行业名称" width="120" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="platform" label="客户端平台" width="120" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createdDate" label="注册时间" width="180" align="center" :formatter="row => $date.format('yyyy-MM-dd hh:mm:ss', row.createdDate)"></el-table-column>
          <el-table-column prop="lastLoginDate" label="最后登录时间" width="180" align="center" :formatter="row => $date.format('yyyy-MM-dd hh:mm:ss', row.lastLoginDate)"></el-table-column>
          <el-table-column label="操作" width="140" align="center">
            <template slot-scope="{row}">
              <el-button type="text" size="small" @click="$router.push({
                path: '/user/template/list',
                query: {
                  userPhone: row.phone
                }
              })">查看模版</el-button>
              <el-button v-if="row.ifAdmin === 1" type="text" size="small" @click="delAdmin(row)">取消管理员</el-button>
              <el-button v-else type="text" size="small" @click="setAdmin(row)">设置为管理员</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="40px">
        <el-row type="flex" align="middle" justify="center">
          <el-pagination :current-page="page"  :total="total" :page-size="size" layout="slot, prev, pager, next, jumper" @current-change="handleCurrentChange">
            <span>
              共<span class="total">{{total}}</span>条
            </span>
          </el-pagination>
        </el-row>
      </el-footer>
    </el-container>
    <v-edit-dialog :visible="editDialogVisible" :item="item" @close="editDialogVisible = false" @update="reload"></v-edit-dialog>
  </v-container>
</template>

<script>

import MainLayout from '@/components/layout/main-header_main_footer'
import EditDialog from './edit-dialog'
import { GET_USERS, PUT_USERS_ADMIN, DEL_USERS_ADMIN } from '@/utils/api'
import { SEX_MAP, USER_STATUS_MAP } from '@/utils/global-constant'

export default {
  name: 'UserList',

  components: {
    'v-container': MainLayout,
    'v-edit-dialog': EditDialog
  },

  data () {
    return {
      form: {
        phone: ''
      },
      USER_STATUS_MAP,
      SEX_MAP,
      page: 1,
      size: 20,
      total: 0,
      loading: false,
      editDialogVisible: false,
      item: {},
      list: []
    }
  },

  watch: {
    size () {
      this.page = 1
    },

    page () {
      this.getList()
    },

    total (value) {
      if (value < (this.page - 1) * this.size) {
        this.page = 1
      }
    }
  },

  async created () {
    this.getList()
  },

  methods: {
    // 获取应用列表
    getList () {
      const data = {
        size: this.size,
        page: this.page,
        ...this.form
      }
      this.loading = true
      GET_USERS(data).then(r => {
        if (r && r.status === 200) {
          this.total = r.data.total
          this.list = r.data.list
        }
        this.loading = false
      })
    },

    // 列表类名
    tableRowClassName({row, rowIndex}) {
      return rowIndex%2 === 1 ? 'warning-row' : 'success-row'
    },

    // 页面切换
    handleCurrentChange (page) {
      this.page = page
    },

    // 新增事件
    add () {
      this.item = {}
      this.editDialogVisible = true
    },

    // 编辑事件
    edit (row) {
      this.item = row
      this.editDialogVisible = true
    },

    isNeedPageDown () {
      return new Promise((resolve, reject) => {
        const page = this.page
        while (this.total <= (this.page - 1) * this.size) {
          this.page--
        }
        page < this.page ? resolve() : reject()
      })
    },

    // 重载
    reload () {
      this.editDialogVisible = false
      this.getList()
    },

    setAdmin ({ id }) {
      this.$confirm('确定设置该用户为管理员?', '操作确认', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        customClass: 'confirm-box'
      }).then(() => {
        PUT_USERS_ADMIN(id).then(r => {
          if (r && r.status === 200) {
            this.reload()
          }
        })
      }).catch(() => {})
    },

    delAdmin ({ id }) {
      this.$confirm('确定取消该用户管理员?', '操作确认', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        customClass: 'confirm-box'
      }).then(() => {
        DEL_USERS_ADMIN(id).then(r => {
          if (r && r.status === 200) {
            this.reload()
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.el-header {
  background-color: #ffffff;
  padding: 20px;
  padding-bottom: 0;
}
</style>
